// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"questionContent_wrapper__1CciB","minimal":"questionContent_minimal__95sLR"};